<template>
  <article class="db-media-card">
    <div class="db-media-card-img" role="button" tabindex="0" :aria-label="'Ver fotos de ' + imagetitle" @click="emit('openGallery')" @keydown.enter="emit('openGallery')">
      <img v-img-fallback v-if="imageSrc && !error" :src="`${base}/img/minGallery/${imageSrc}`" :alt="imagetitle" loading="lazy" @error="error = true" />
      <span v-else class="db-media-card-placeholder">
        <span class="material-symbols-outlined">photo_library</span>
      </span>
      <span v-if="esPortada" class="db-badge db-badge--gold">
        <span class="material-symbols-outlined">home</span> Carrusel de portada
      </span>
      <span v-else-if="protegida" class="db-badge db-badge--info">
        <span class="material-symbols-outlined">lock</span> Protegida
      </span>
    </div>

    <div class="db-media-card-body">
      <h3 class="db-media-card-title">{{ imagetitle }}</h3>
    </div>

    <div class="db-media-card-actions">
      <button type="button" class="db-btn db-btn--ghost db-btn--sm" @click="emit('openGallery')">
        <span class="material-symbols-outlined">photo_library</span> Fotos
      </button>
      <button
        v-if="!esPortada"
        type="button"
        class="db-icon-btn"
        title="Editar título y portada"
        aria-label="Editar galería"
        @click="emit('editGallery')"
      >
        <span class="material-symbols-outlined">edit</span>
      </button>
      <button
        v-if="!esPortada && !protegida"
        type="button"
        class="db-icon-btn db-icon-btn--danger"
        title="Eliminar galería"
        aria-label="Eliminar galería"
        @click="emit('deleteGallery')"
      >
        <span class="material-symbols-outlined">delete</span>
      </button>
    </div>
  </article>
</template>

<script>
export default {
  name: "cardViewconf",
  props: ["imageSrc", "imagetitle", "imageDescription", "idGallery"],
  data() {
    return {
      error: false,
      base: this.$media,
    };
  },
  computed: {
    // La galería 1 alimenta el carrusel de la portada; la 2 no se puede borrar
    esPortada() {
      return this.idGallery == 1;
    },
    protegida() {
      return this.idGallery == 2;
    },
  },
  methods: {
    emit(action) {
      this.$emit("iconClick", {
        id: this.idGallery,
        title: this.imagetitle,
        imageSrc: this.imageSrc,
        tituloNoticia: this.imagetitle,
        descripNoticia: this.imageDescription,
        action,
      });
    },
  },
};
</script>
